import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgTochtwering = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F8BADD"
      fillRule="evenodd"
      d="M29.64 10.12h1.92a3.44 3.44 0 0 1 0 6.88H25a5 5 0 1 1 4.64-6.88"
      clipRule="evenodd"
    />
    <path
      fill="#F170B8"
      fillRule="evenodd"
      d="m15 9 10 8v16H5V17z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M27.727 21.419c-.222-.142-.373-.239-.727-.239v-1c.644 0 .994.222 1.27.399l.003.002c.222.142.373.239.727.239s.505-.097.727-.239l.003-.002c.276-.177.626-.399 1.27-.399s.994.222 1.27.399l.003.002c.222.142.373.239.727.239s.505-.097.727-.239l.004-.002c.275-.177.625-.399 1.269-.399v1c-.354 0-.505.097-.727.239l-.004.002c-.275.177-.625.399-1.269.399s-.994-.222-1.27-.399l-.003-.002c-.222-.142-.373-.239-.727-.239s-.505.097-.727.239l-.003.002c-.276.177-.626.399-1.27.399s-.994-.222-1.27-.399zM23.727 25.419c-.222-.142-.373-.239-.727-.239v-1c.644 0 .994.222 1.27.399l.003.002c.222.142.373.239.727.239s.505-.097.727-.239l.003-.002c.276-.177.626-.399 1.27-.399s.994.222 1.27.399l.003.002c.222.142.373.239.727.239s.505-.097.727-.239l.003-.002c.276-.177.626-.399 1.27-.399v1c-.354 0-.505.097-.727.239l-.003.002c-.276.177-.626.399-1.27.399s-.994-.222-1.27-.399l-.003-.002c-.222-.142-.373-.239-.727-.239s-.505.097-.727.239l-.003.002c-.276.177-.626.399-1.27.399s-.994-.222-1.27-.399zM25.727 29.419c-.222-.142-.373-.239-.727-.239v-1c.644 0 .994.222 1.27.399l.003.002c.222.142.373.239.727.239s.505-.097.727-.239l.003-.002c.276-.177.626-.399 1.27-.399s.994.222 1.27.399l.003.002c.222.142.373.239.727.239s.505-.097.727-.239l.003-.002c.276-.177.626-.399 1.27-.399v1c-.354 0-.505.097-.727.239l-.004.002c-.275.177-.625.399-1.269.399s-.994-.222-1.27-.399l-.003-.002c-.222-.142-.373-.239-.727-.239s-.505.097-.727.239l-.003.002c-.276.177-.626.399-1.27.399s-.994-.222-1.27-.399z"
      clipRule="evenodd"
    />
    <path
      fill="#F8BADD"
      d="M15.83 22.17h-6.5V33h6.5z"
    />
    <path
      fill="#F8BADD"
      fillRule="evenodd"
      d="M22.5 31V19h1v12z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgTochtwering);

export default ForwardRef;
